// import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
// import { AuthProvider } from '../../application/interactors/core'
import InicioEstudiante from '../view/Inicio/InicioEstudiante'
import { AppProcesoMatricula } from './AppProcesoMatricula'

export const AppEstudiante = () => {
    return (
        <Router>
            <div>
                <Switch>
                    <Route exact path="/Inicio" component={InicioEstudiante} />
                    <Route path="/" component={AppProcesoMatricula} />
                </Switch>
            </div>
        </Router>
    )
}
